import { ArrowOutward } from "@mui/icons-material";
import {
    Box,
    Link,
    TableBody,
    TableCell,
    TableRow,
    Typography,
    styled,
} from "@mui/material";

export const S = {
    Hero: styled(Box)(({ theme }) => ({
        background: "#eaf6ec",
        padding: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(7),
        borderRadius: theme.spacing(2),
    })),

    Header: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    })),

    Title: styled(Typography)(({ theme }) => ({
        fontWeight: 700,
        fontSize: 16,
    })),

    Description: styled(Typography)(({ theme }) => ({
        fontWeight: 400,
        fontSize: 14,
    })),

    BankList: styled(Box)(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(6),
    })),

    BankCard: styled(Box)(({ theme }) => ({
        flex: 1,
        borderRadius: theme.spacing(2),
    })),

    BankTitle: styled(Typography)(({ theme }) => ({
        fontWeight: 700,
        color: "#1a237e",
        marginBottom: theme.spacing(2),
    })),

    TableHeader: styled(TableCell)(() => ({
        fontWeight: 700,
        fontSize: 12,
    })),

    TableBody: styled(TableBody)(({ theme }) => ({
        background: "#fff",
    })),

    TableRow: styled(TableRow)(({ theme }) => ({
        marginBottom: theme.spacing(1),
    })),

    TableLabel: styled(TableCell)(() => ({
        fontWeight: 700,
        color: "#40905B",
        fontSize: 12,
        borderRight: "1px solid #E5E5E5;",
    })),

    TableCell: styled(TableCell)(() => ({
        fontWeight: 400,
        fontSize: 12,
        color: "#40905B",
    })),

    Footer: styled(Box)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
        marginTop: theme.spacing(3),
    })),

    Link: styled(Link)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3),
        fontWeight: 400,
        fontSize: 14,
        textDecoration: "underline",
    })),

    ArrowIcon: styled(ArrowOutward)(({ theme }) => ({
        fontSize: 16,
    })),
};
